<rt-dialog-header
  [heading]="'app.candidate.add_email_dialog.heading' | translate"
></rt-dialog-header>
<rt-dialog-body layout-vertical>
  <rt-infobox iconName="info-outline" [isDismissible]="false">
    {{ 'app.candidate.add_email_dialog.infobox' | translate }}
  </rt-infobox>
  <rt-form-field margin-top-medium>
    <rt-label>{{ 'app.candidate.email' | translate }}</rt-label>
    <rt-input
      [formControl]="emailControl"
      [placeholder]="'app.candidate.email_placeholder' | translate"
      (keydown.enter)="!emailControl.invalid && save()"
      variant="rounded"
    ></rt-input>
  </rt-form-field>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" (click)="cancel()" margin-right-small>
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="primary" [disabled]="emailControl.invalid" (click)="save()">
    {{ 'app.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
